import React, { useContext, useState } from "react";

import { NetworkError } from "@apollo/client/errors";
import { GraphQLFormattedError } from "graphql";

type TLoadingContextError = GraphQLFormattedError | NetworkError | Error;

type TLoadingContext = {
  error: TLoadingContextError | undefined;
};

const LoadingContext = React.createContext<TLoadingContext | undefined>(
  undefined,
);
const SetLoadingContext = React.createContext<
  React.Dispatch<React.SetStateAction<TLoadingContext>> | undefined
>(undefined);

export function useUpdateLoadingContext() {
  const updateFn = useContext(SetLoadingContext);
  if (!updateFn) {
    throw new Error("Must be used within WithLoadingContext");
  }
  return updateFn;
}

export function useLoadingContext() {
  return useContext(LoadingContext);
}

export function WithLoadingContext({
  children,
}: {
  children: React.ReactNode;
}) {
  const [loadingContext, setLoadingContext] = useState<TLoadingContext>({
    error: undefined,
  });
  return (
    <SetLoadingContext.Provider value={setLoadingContext}>
      <LoadingContext.Provider value={loadingContext}>
        {children}
      </LoadingContext.Provider>
    </SetLoadingContext.Provider>
  );
}
